import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-base leading-7 text-gray-600" }
const _hoisted_2 = { class: "text-2xl font-bold tracking-tight text-gray-900 flex items-center gap-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Financing Options", -1)
const _hoisted_4 = { class: "my-3 text-base leading-7 text-gray-600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 font-medium" }, "1356 verified originators", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewspaperIcon = _resolveComponent("NewspaperIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createVNode(_component_NewspaperIcon, { class: "inline-block h-7 w-7 mr-2" }),
      _hoisted_3
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createTextVNode(" Submit your deal exclusively to " + _toDisplayString(_ctx.originator.Name.split(' ')[0]) + " or select to provide access for ", 1),
      _hoisted_5,
      _createTextVNode(" at Janover and choose the best quote. ")
    ]),
    _createElementVNode("button", {
      class: "inline-flex bg-sky text-white items-center justify-center text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background bg-primary text-primary-foreground hover:bg-primary/90 h-11 px-8 rounded-md mt-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalGetQuotePublic', { originator: _ctx.originator })))
    }, " Get a Quote   → ")
  ]))
}